<template>
    <div>
        <el-form :model="menuAdd">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="上级菜单">
                        <el-input type="text" v-model="menuAdd.parentName" :disabled="true" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="层级">
                        <el-input type="text" v-model="addLevel" :disabled="true" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="菜单名称">
                        <el-input type="text" v-model="menuAdd.name" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="选择类型">
                        <el-select v-model="menuAdd.type" placeholder="请选择">
                            <el-option label="菜单" value="1"></el-option>
                            <el-option label="操作" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="地址">
                        <el-input type="textarea" v-model="menuAdd.url" autocomplete="off" :autosize="{ minRows: 2, maxRows: 6}" placeholder="多个路径用,隔开"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="component路径">
                        <el-input type="text" v-model="menuAdd.vueComponent" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="component名称">
                        <el-input type="text" v-model="menuAdd.componentName" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="排序">
                        <el-input type="text" v-model="menuAdd.sort" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="图标">
                        <el-input type="text" v-model="menuAdd.icon" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-switch
                            v-model="menuAdd.showMenu"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            inactive-text="首页菜单是否显示"
                    >
                    </el-switch>
                </el-col>
            </el-row>
        </el-form>
        <el-row :gutter="20" style="margin-top: 10px;text-align: center">
	  		<el-button @click="cancel">取 消</el-button>
	  		<el-button type="primary" @click="saveOrUpdate">提交</el-button>
	  	</el-row>
    </div>
</template>

<script>

export default {
    name: 'SysMenuEdit',
    props:['menuAdd','editType','addLevel'],
    data:function(){
        return {

        }
    },
    methods:{
        saveOrUpdate(){
            this.$emit('submit')
        },
        cancel(){
            this.$emit('cancel')
        }
    }
};
</script>

<style scoped>
.dialog-footer{
    display: flex;
    align-content: center;
}
</style>